"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmeraldAccordionCoreInputs = void 0;
class EmeraldAccordionCoreInputs {
    constructor() {
        this.id = Math.random().toString(36).substring(7);
        this.tabIndex = 0;
        this.open = false;
        this.openIcon = 'expand_less';
        this.closeIcon = 'expand_more';
        this.iconPosition = 'right';
        this.disabled = false;
    }
}
exports.EmeraldAccordionCoreInputs = EmeraldAccordionCoreInputs;
//# sourceMappingURL=accordion.inputs.js.map